<template>
  <div class="bmi-box">
    <span class="title">孕产期自测</span>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="您的平均月经周期（天）：" :label-col="{span: 5}" :wrapper-col="{span: 5}">
        <a-input
            placeholder="请输入天数"
            type="number"
            v-decorator="['menstruationCycle',{initialValue: 28,rules:[{required: true, message: '请输入您的平均月经周期!'}]}]" />
      </a-form-item>
      <a-form-item label="您的末次月经时间：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-date-picker
            @change="onDateChange"
            v-decorator="['menstruationLastDay',{rules:[{required: true, message: '请选择您的末次月经时间!'}]}]" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">
          查看结果
        </a-button>
      </a-form-item>
    </a-form>
    <div class="result-box" v-if="result._EDC">
      <div class="result-text">测试结果</div>
      <div class="result">
        您的孕产期为：<span class="edc">{{ result._EDC }}</span>
        <span class="desc">{{ result.desc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      form: this.$form.createForm(this, {}),
      result: {
        _EDC: '',
        desc: ''
      }
    };
  },

  methods: {
    /**
     * 日期修改时回调
     * @param date Date
     * @param dateString YYYY-MM-DD
     */
    onDateChange(date, dateString) {
      if (dateString.length === 0) {
        this.result._EDC = '';
        this.result.desc = '';
      }
    },

    /** 提交查看结果 */
    handleSubmit() {
      this.form.validateFields((error, values) => {
        if (error === null) {
          let menstruationCycle = values['menstruationCycle']
          let trueNumber = 280;
          if (menstruationCycle < 28) {
            trueNumber = 280 - (28 - menstruationCycle);
          } else if (menstruationCycle > 28) {
            trueNumber = 280 + (menstruationCycle - 28);
          }

          let resultDay = moment(values['menstruationLastDay']).add(trueNumber, 'day')
          this.result._EDC = resultDay.format('YYYY-MM-DD');

          if (moment().isAfter(resultDay)) {
            this.result.desc = ' ；您已过预产期';
            return;
          }

          if (moment().isBefore(moment(values['menstruationLastDay']))) {
            this.result.desc = '';
            return;
          }

          let currentWeeks = moment().diff(moment(values['menstruationLastDay']), 'week');
          this.result.desc = ` ；现在正处于孕期的第${currentWeeks}周`;
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.bmi-box {
  padding-left: 15px;

  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    display: inline-block;
  }

  .result-box {
    margin-top: 20px;

    .result-text {
      font-size: 16px;
      font-weight: bold;
    }

    .result {
      margin: 10px;

      .edc {
        font-weight: bold;
        color: #ff0c0c;
      }
    }
  }
}
</style>